module.exports = __webpack_public_path__ + "img/dotd-logo.f83bd5e8.png";